import React from 'react';
import { Yes } from '../icons/Icons';

const PageResults = (props) => {

  return (
    <div className="kids-quiz__page">
      <div className="kids-quiz__question ui">
        <img className="inline-results-logo" src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/collab-logo--green.png?v=1620131847" alt="Patina and Nourished collaboration logo" />
        <p className="question__title">{props.kidsName}, here is the product we recommend for you!</p>
        <p className="inline-results-p">{props.blend}</p>
        <div className="inline-results">
          <img src={props.blendImageUrl} />
          <ul>
            {props.blendHighlights.map((item, index) => (
              <li key={index}><Yes />{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PageResults;